import { browserHistory } from 'react-router';
import { get, isEmpty, makeSlug } from '../../utils';
import { getModelLineBySlug, getModelLines } from '../selectors/models';
import { getNcodeBySlugAndModelLineCode } from '../selectors/trim';
import { getAllModelLines, getTrimsByModelLineCode, getBestOfferOptions } from '../../services';
import { isConstructedTrim, getURLNCode } from '../selectors/helios';
import {
  GET_ALL_MODELLINES,
  GET_ALL_MODELLINES_SUCCEEDED,
  GET_ALL_MODELLINES_FAILED,
  GET_MODEL_TRIMS,
  GET_MODEL_TRIMS_SUCCEEDED,
  GET_MODEL_TRIMS_FAILED,
  UPDATE_ROUTE_PARAMS,
  GET_BEST_OFFERS,
  GET_BEST_OFFERS_SUCCEEDED,
  GET_BEST_OFFERS_FAILED,
  USER_EXTERNAL_LINK,
} from '../constants';

const shouldFetchModelLines = (state) => {
  const models = getModelLines(state);
  return isEmpty(models);
};

const fetchModelLines = (dispatch, state) => new Promise((resolve, reject) => {
  if (!shouldFetchModelLines(state)) {
    resolve();
    return;
  }
  // 1 - Ensure all model lines are loaded.
  dispatch({
    type: GET_ALL_MODELLINES
  });
  getAllModelLines(state).then((result) => {
    dispatch({
      type: GET_ALL_MODELLINES_SUCCEEDED,
      result
    });
    resolve();
  })
    .catch((error) => {
      if (error) {
        // eslint-disable-next-line
        console.error(error.stack);
      }
      dispatch({
        type: GET_ALL_MODELLINES_FAILED,
        error
      });
      reject()
    });
});

const shouldFetchModelTrims = (state, modelLineSlug) => {
  if (!modelLineSlug) {
    return false;
  }
  const modelLine = getModelLineBySlug(state, modelLineSlug);
  if (!modelLine) {
    return false;
  }
  return true;
};

const fetchModelLineTrims = (dispatch, state, params) => new Promise((resolve, reject) => {
  if (!shouldFetchModelTrims(state, params.model)) {
    resolve();
    return;
  }
  const modelLine = getModelLineBySlug(state, params.model);
  const modelLineCode = modelLine.modelLineCode;

  dispatch({
    type: GET_MODEL_TRIMS,
    modelLineCode
  });
  getTrimsByModelLineCode(state, modelLineCode)
    .then((result) => {
      dispatch({
        type: GET_MODEL_TRIMS_SUCCEEDED,
        modelLineCode,
        result
      });
      resolve();
    })
    .catch((error) => {
      if (error) {
        // eslint-disable-next-line
        console.error(error.stack);
      }
      dispatch({
        type: GET_MODEL_TRIMS_FAILED,
        modelLineCode,
        error
      });
      reject();
    });
});

const shouldFetchTrimsAndIncentives = (state) => {
  const nCode = get(state, 'navigation.nCode');
  const zipCode = get(state, 'dma.zipCode');
  const creditRating = get(state, 'userAmounts.creditRating');
  return (nCode && zipCode && creditRating);
};

const fetchPaymentOptions = (dispatch, state) => new Promise((resolve, reject) => {
  if (!shouldFetchTrimsAndIncentives(state)) {
    resolve();
    return;
  }

  dispatch({
    type: GET_BEST_OFFERS
  });

  const onGetOptions = (result) => {
    dispatch({
      type: GET_BEST_OFFERS_SUCCEEDED,
      offers: result,
      target: result.target,
    });
    resolve(result.options);
  };

  const onError = (error) => {
    if (error && error.stack) {
      // eslint-disable-next-line
      console.error(error.stack);
    }
    dispatch({
      type: GET_BEST_OFFERS_FAILED,
      error
    });
    reject();
  };

  getBestOfferOptions(state)
    .then(onGetOptions, onError)
    .catch(onError);
});

export function updateRouteParams(params) {
  return (dispatch, getState) => {
    // const redirectToLandingPage = () => {
    //   const landingPage = getState().config.landingPage || '';
    //   const redirect = `${landingPage}${window.location.search}`;
    //   browserHistory.push(redirect);
    // }

    fetchModelLines(dispatch, getState()).then(() => {
      fetchModelLineTrims(dispatch, getState(), params).then(() => {
        const state = getState();
        const model = getModelLineBySlug(state, params.model);
        let enhancedParams = {};
        const nCode = isConstructedTrim(state) ? getURLNCode(state) : getNcodeBySlugAndModelLineCode(state, params.trim, model.modelLineCode); //eslint-disable-line
        if (model) {
          enhancedParams = {
            modelSlug: model.slug,
            trimSlug: makeSlug(params.trim),
            nCode,
            modelLineCode: model.modelLineCode
          };
          dispatch({
            type: UPDATE_ROUTE_PARAMS,
            params: enhancedParams
          });
          fetchPaymentOptions(dispatch, getState()).then((paymentOptions) => {
            /* eslint-disable */
            // if we don't have any valid incentives after loading from the service,
            // we need to redirect to the no incentives view.
            // eslint-disable-next-line
            if (paymentOptions && paymentOptions.hasValidData === false) {
              const incentivesRoute = '/no-incentives';
              const currentRoute = get(getState(), ['routing', 'locationBeforeTransitions', 'pathname']);
              if (!currentRoute.endsWith(incentivesRoute)) {
                browserHistory.push(`${currentRoute}${incentivesRoute}${window.location.search}`);
              }
            }
            /* eslint-enable */
          }).catch((err) => {
            dispatch({
              type: GET_BEST_OFFERS_FAILED,
              err
            });
            // redirectToLandingPage();
          });
          // return;
        }
        // if a model param was specified, but we don't
        // have a model, it means we should probably
        // handle similar to a 404 scenario and continue no further
        // if (params.model && !model) {
        //   // eslint-disable-next-line
        //   console.error('model param was specified, but no model found', params.model, model);
        //   dispatch({
        //     type: INVALID_MODELINE_ROUTE,
        //     modelLineSlug: params.model
        //   })
        //   redirectToLandingPage();
        // }
      });
    });
  };
}

export function link(name, url) {
  return (dispatch) => {
    dispatch({
      type: USER_EXTERNAL_LINK,
      name,
      url
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/navigation.js
 **/